<template>
  <v-dialog
      v-model="scanner_active"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
  >
    <v-card>
      <v-toolbar
          dark
          color="primary"
      >
        <v-spacer></v-spacer>
        <v-toolbar-title>{{ overlay_title }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn
            icon
            dark
            @click="userCanceled"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <v-row
            align="center"
            class="mx-0"
        >
      <SharedQrCodeScannerComponent
          :displayExitBtnOnError="true"
          :errorBtnText="$vuetify.lang.t('$vuetify.tag_code_scanner.overlay_view.errors.error_btn_txt')"
          @decodedQr="validateQRTAGData"
          @closedScannerError="closeWithError"
          @criticalError="scanner_has_critical_error = $event">
      </SharedQrCodeScannerComponent>
        </v-row>

        <v-row v-if="!scanner_has_critical_error"
               align="center"
               class="mx-0">
            <v-col cols="12" class=" text-center">
            <p style="font-size: 12px;" class="text-center">{{ $vuetify.lang.t('$vuetify.tag_code_scanner.overlay_view.info_manual') }}</p><!--  -->
              <v-btn text dark small style="text-decoration: underline; font-size: 12px;color:rgba(0, 0, 0, 0.6);text-transform: none;" @click="unlockInput">
                {{ $vuetify.lang.t('$vuetify.tag_code_scanner.overlay_view.manual_btn') }}
              </v-btn>
            </v-col>

        </v-row>
      </v-card-text>
    </v-card>
    <simple-popup-component
        :is-visible="display_scan_error"
        :title="error_title"
        :body="error_body"
        @positive_btn_clicked="display_scan_error = false"
    ></simple-popup-component>
  </v-dialog>
</template>

<script>
import {TAGCodeValidator} from "@/helpers/capSettings/TAGCodeValidator";
import SimplePopupComponent from "@/components/modules/global/simplePopup/SimplePopupComponent";
import SharedQrCodeScannerComponent from "@/components/modules/qrCodeScanner/SharedQrCodeScannerComponent";

export default {
  name: "CAPSTAGCodeScanOverlayComponent",
  props: {
    scanner_active: {
      type: Boolean,
      default: false
    }
  },
  components: {SimplePopupComponent, SharedQrCodeScannerComponent},
  data() {
    return {
      overlay_title: '',
      scanner_has_critical_error: false,
      display_scan_error: false,
      error_title: '',
      error_body: '',
    }
  },
  methods: {
    userCanceled() {
      if (this.scanner_has_critical_error) {
        this.closeWithError();
      } else {
        this.$emit('userCanceled');
      }

    },
    unlockInput(){
      this.$emit('unlockTAGInput');
    },
    closeWithError() {
      this.$emit('closedWithError');
    },
    validateQRTAGData($QRData) {
      if (TAGCodeValidator.validate_TAG_CODE($QRData)) {
        this.$emit('validTAGScanned', $QRData);
      } else {
        this.display_scan_error = true;
        this.error_title = this.$vuetify.lang.t('$vuetify.tag_code_scanner.overlay_view.errors.invalid_tag_title');
        this.error_body = this.$vuetify.lang.t('$vuetify.tag_code_scanner.overlay_view.errors.invalid_tag_body');
      }
    }
  },
  mounted() {
    this.overlay_title = this.$vuetify.lang.t('$vuetify.tag_code_scanner.overlay_view.title');
  }
}
</script>

<style scoped>

</style>